module.exports = __webpack_public_path__ + "static/img/guide1.75cd726.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guide1.webp
// module id = yp61
// module chunks = 1